import variableReducer from "./reducers";

export default variableReducer;